import React, { useState } from "react"
import Wallets1 from "../../assets/wallets1.jpeg"
import secure from "../../assets/secure.jpg"
import carguy from "../../assets/carguy.png"
import { Link } from "react-router-dom"
import Msafiri from "./Msafiri"
import Mradi from "./Mradi"
import Wezesha from "./Wezesha"



const features = [
    { name: 'Msafiri (Travel) Wallet', description: <Msafiri/>, },
    { name: 'Mradi (Project) Wallet.', description: <Mradi/> },
    { name: 'Wezesha (Biashara) Wallet.', description: <Wezesha/> },
  ]

  
  export default function Wallets() {


   




    return (
      <div className="bg-white">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Imarika Wallets</h2>
            <p className="mt-4 text-gray-500">
            Britam understands that you are unique and your way of saving is different from anyone else out there. That is why we have designed something special that will work for you, at your own pace in your own way through a range of digital savings wallets known as Imarika Wallets.
            </p>
            <p  className="mt-4 text-gray-500">The Digital Wallets are goal based investment wallets available on our USSD *778# platform under the “Imarika Wallets” option. In addition, once you open any of the three wallets, you have an option to name your wallet as you so wish.</p>
  
            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              {features.map((feature) => (
                
                <div key={feature.name}  className="border-t border-gray-200 pt-4">
                  <dt className="font-medium text-gray-900">{feature.name}</dt>
                  <dd className="mt-2 text-sm text-gray-500">{feature.description}</dd>
                </div>
              
              ))}
            </dl>
          </div>
          <div className="grid grid-cols-2 grid-rows-2 gap-4 sm:gap-6 lg:gap-8">
            <img
              src={Wallets1}
              alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
              className="rounded-lg bg-gray-100"
            />
            <img
              src={secure}
              alt="Top down view of walnut card tray with embedded magnets and card groove."
              className="rounded-lg  bg-gray-100"
            />
            <img
              src={carguy}
              alt="Side of walnut card tray with card groove and recessed card area."
              className="rounded-lg h-90 bg-gray-100"
            />
         
          </div>
        </div>
      </div>
    )
  }
  